module.exports = __webpack_public_path__ + "static/media/forside.c957127d.jpg";